import React from "react";
import { Helmet } from "react-helmet";
// APIs
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContextProvider";
import DashBoardb2b from "../../components/Dashboard/DashBoard";
import DashboardDoctor from '../../components/Dashboard/DoctorDashboard';


const Insights = () => {
  const { user } = useContext(AuthContext);

  return (
    <>
      <Helmet>
        <title>Spandan - Dashboard</title>
      </Helmet>

      {user?.userType === "b2b-doctor" ? (
        <DashboardDoctor permissions={user.permissions} />
      ) : (
       <DashBoardb2b/>
      )}
    </>
  );
};

export default Insights;